import React from 'react';
import './style.css';

// Helper function to get dice image based on value
const getDiceImage = (value) => {
  const diceValue = parseInt(value) || 1;
  return `https://d1arlbwbznybm5.cloudfront.net/v19/static/front/images/sicbo/dice${diceValue}.png`;
};

// Helper function to parse card string (e.g., "2,3,4" or "3,5,6")
const parseDiceValues = (cardString) => {
  if (!cardString) return [];
  return cardString.split(',').map(v => v.trim());
};

const Sicbo = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const diceValues = detailResult?.card ? parseDiceValues(detailResult.card) : [];
  const winValue = detailResult?.win || '';

  return (
    <div>
      <h6 className="text-right round-id" style={{ marginBottom: '1rem' }}>
        <b>Round Id:</b> {roundId}
      </h6>
      <div className="col-12">
        <div className="text-center luckyseven-img">
          <div className="row">
            {diceValues.map((value, idx) => (
              <div key={idx} className="col-1">
                <img
                  src={getDiceImage(value)}
                  alt={`Dice ${value}`}
                  style={{ width: '100%', maxWidth: '50px', height: 'auto' }}
                  onError={(e) => {
                    e.target.src = `/assets/img/tabledice/dice${value}.png`;
                  }}
                />
              </div>
            ))}
          </div>
        </div>
        {winValue && (
          <div className="text-center mt-3">
            <div>
              <b className="text-success">Result: </b>
              {diceValues.join(',')} | Win: {winValue}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sicbo;

